export const stringifyFormData = (fd :FormData) => {
    const data : any = {};
    const keys : Array<string> = fd.keys() as unknown as Array<string>
      for (let key  of keys) {
        data[key] = fd.get(key);
    }
    return JSON.stringify(data, null, 2);
  }


  export const objectFormData = (fd :FormData) => {
    const data : any = {};
    const keys : Array<string> = fd.keys() as unknown as Array<string>
      for (let key  of keys) {
        data[key] = fd.get(key);
    }
    return data;
  }